import dayjs, { Dayjs } from "dayjs";
import { default as relativeTimePlugin } from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTimePlugin);

export function isMs(num: number): boolean {
  return `${num}`.length >= 13;
}

export function containsNonNumeric(str: string): boolean {
  return /[^$,.\d]/.test(str);
}

export function toDayjs(date: number | string | Date | Dayjs): Dayjs {
  if (date instanceof Date) {
    return dayjs(date);
  }
  if (typeof date === "string") {
    if (containsNonNumeric(date)) {
      return dayjs(date);
    }
    date = parseInt(date, 10);
  }
  if (typeof date === "number") {
    if (isMs(date)) {
      return dayjs(date);
    }
    return dayjs.unix(date);
  }
  return date;
}

export function relativeTime(
  firstDate: Date | string | number | Dayjs,
  secondDate: Date | string | number | Dayjs = dayjs()
): string {
  firstDate = toDayjs(firstDate);
  secondDate = toDayjs(secondDate);

  return firstDate.from(secondDate);
}
